import { createContext, useReducer, useMemo } from "react";
import dynamic from "next/dynamic";

// import SinglePostModal from "@components/post/SinglePostModal";
const SinglePostModal = dynamic(
  () => import("@components/post/SinglePostModal"),
  {
    ssr: false,
  }
);

export const ViewSinglePostModalContext = createContext();

const initialState = {
  openModal: false,
  postData: null,
  closeModal: null,
  currentViewerRole: null,
  changeViewerRole: null,
};

function reducer(state, action) {
  switch (action.type) {
    case "OPEN":
      if (action?.payload?.postData) {
        const newState = {
          openModal: true,
          ...action.payload,
        };

        return newState;
      }

      return state;

    case "CLOSE":
      return initialState;

    default:
      return state;
  }
}

export function ViewSinglePostModalProvider(props) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const value = useMemo(() => {
    return {
      state,
      dispatch,
    };
  }, [state]);

  return (
    <ViewSinglePostModalContext.Provider value={value}>
      <>
        {props.children}

        {state.openModal && (
          <SinglePostModal
            {...state}
            closeModal={() => dispatch({ type: "CLOSE" })}
          />
        )}
      </>
    </ViewSinglePostModalContext.Provider>
  );
}
